import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  align-items: flex-end;
`

export const Image = styled.img`
  width: 100%;
`
